import type { ReactNode } from "react";
import Box from "@mui/material/Box";

/**
 * Bar that sticks to the bottom of the screen on phones, for a page's
 * Save button when the page does not use FormPageLayout (whose phone bar
 * does the same job). Place it as the last child of the page's form so it
 * scrolls with the form and then pins. It bleeds across the page's 16 px
 * phone gutter.
 */
export function PhoneSaveBar({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 2,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 1,
        mx: -2,
        mt: 3,
        px: 2,
        py: 1.5,
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      {children}
    </Box>
  );
}
